import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import myConnections from "../../utility/connect"

const sliceName = "userSlice"
const stateName = "userState"

export const initialState = {
  name: null,
  surname: null,
  birthDate: null,
  gender: null,
  currentPeriod: { points: null, tier: null, tierName: null },
  nextPeriod: {
    points: null,
    tier: null,
    tierName: null,
    nextPeriodDate: null,
  },
  mobile: null,
  mobileCountryStart: null,
  fullMobile: null,
  postalCode: null,
  postalCity: null,
  email: null,
  townCity: null,
  permission1: null,
  permission2: null,
  permission3: null,
  permission4: null,
  virtualCards: [],
  physicalCards: [],
  reference: null,

  points: [],
  messages: [],
  rewards: { cupons: [], tierRewards: [] },
}

/***
 *                _ _                                           _            _
 *       __ _ ___(_) |__  _ __ ___  _ __   ___   _ __ ___   ___| |_ ___   __| | ___
 *      / _` / __| | '_ \| '__/ _ \| '_ \ / _ \ | '_ ` _ \ / _ \ __/ _ \ / _` |/ _ \
 *     | (_| \__ \ | | | | | | (_) | | | |  __/ | | | | | |  __/ || (_) | (_| |  __/
 *      \__,_|___/_|_| |_|_|  \___/|_| |_|\___| |_| |_| |_|\___|\__\___/ \__,_|\___|
 *
 */

let getUserInfo = async (_, thunkAPI) => {
  const responsePromise = myConnections.get({
    path: "customers_protected/get_user_info",
    data: {},
    headers: {},
    thunkAPI: thunkAPI,
  })

  const response = await responsePromise

  // if (response.items.length === 0) {
  //   return thunkAPI.rejectWithValue({
  //     noUserFound: true,
  //   });
  // }

  return response
}

getUserInfo = createAsyncThunk(`${sliceName}/getUserInfo`, getUserInfo, {
  getPendingMeta: ({ arg, requestId }, { getState, extra }) => {
    return { baba: "bibi" }
  },
})

getUserInfo.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, action) => {
    const result = action.payload.items[0] ?? {}
    state.name = result.name
    state.currentPeriod.points = result.points
    state.currentPeriod.tier = result.tier
    state.currentPeriod.tierName = result.tier_name
    state.nextPeriod.points = result.next_points
    state.nextPeriod.tier = result.next_tier
    state.nextPeriod.tierName = result.next_tier_name
    state.nextPeriod.nextPeriodDate = result.next_period
    state.surname = result.surname
    state.birthDate = result.birth_date
    state.gender = result.gender
    state.mobile = result.mobile
    state.postalCode = result.postal_code
    state.postalCity = result.postal_city
    state.townCity = result.town_city
    state.email = result.email
    state.mobileCountryStart = result.mobile_country_start
    state.fullMobile = `${result.mobile_country_start ?? ""}${
      result.mobile ?? ""
    }`

    if (state.fullMobile) {
      state.fullMobile = "+" + state.fullMobile
    }

    state.permission1 = result.permission1 === "Y"
    state.permission2 = result.permission2 === "Y"
    state.permission3 = result.permission3 === "Y"
    state.permission4 = result.permission4 === "Y"
    state.channels_code = result.channels_code

    state.physicalCards = result.physical_cards
    state.virtualCards = result.virtual_cards
    state.giveaways = result.giveaways
    state.points = (result.transactions ?? []).map((point) => {
      const newObject = {
        ...point,
        isClickable: (point.id ?? "") !== "",
        transactionId: point.id,
        transactionDetails: point.details,
      }
      delete newObject.id
      delete newObject.details
      return newObject
    })
    state.birthDateChanged = result.birth_date_changed === "Y"
    state.messages = result.messages
    state.reference = result.reference

    const promotions = result.promotions ?? []

    const initialRewards = { ...initialState.rewards }
    state.rewards = initialRewards
    promotions.forEach((promotion) => {
      const type = promotion.promotion_types_code
      if (type === "C") {
        state.rewards.cupons = [...state.rewards.cupons, promotion]
      } else if (type === "T") {
        state.rewards.tierRewards = [...state.rewards.tierRewards, promotion]
      }
    })
  },
  rejected: (state, action) => {},
}

/////////////////////////////PROFILE
let updateCustomer = async (
  {
    name,
    surname,
    birth_date,
    gender,
    permission1,
    permission2,
    permission3,
    permission4,
    town_city,
    postal_code,
    channels_code,
    countryCode,
    mobile,
  },
  thunkAPI
) => {
  const response = await myConnections.post({
    path: "customers_protected/update_customer",
    data: {
      P_NAME: name,
      P_SURNAME: surname,
      P_BIRTH_DATE: birth_date,
      P_GENDER: gender,
      P_PERMISSION1: permission1 ? "Y" : "N",
      P_PERMISSION2: permission2 ? "Y" : "N",
      P_PERMISSION3: permission3 ? "Y" : "N",
      P_PERMISSION4: permission4 ? "Y" : "N",
      P_TOWN_CITY: town_city,
      P_POSTAL_CODE: postal_code,
      P_CHANNELS_CODE: channels_code,
      P_MOBILE: mobile,
      P_MOBILE_COUNTRY_START: countryCode,
    },
    headers: {},
    thunkAPI: thunkAPI,
  })

  return response
}
updateCustomer = createAsyncThunk(`${sliceName}/updateCustomer`, updateCustomer)
updateCustomer.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, action) => {},
  rejected: (state, action) => {},
}

/////////////////////////////CHANGE PASSWORD

let changePassword = async (
  { currentPasword, newPassword, repeatedNewPassword },
  thunkAPI
) => {
  const response = await myConnections.post({
    path: "customers_protected/change_password",
    data: {
      P_OLD_PASSWORD: currentPasword,
      P_NEW_PASSWORD: newPassword,
      P_NEW_PASSWORD_CONFIRM: repeatedNewPassword,
    },
    headers: {},
    thunkAPI: thunkAPI,
  })

  return response
}
changePassword = createAsyncThunk(`${sliceName}/changePassword`, changePassword)
changePassword.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, { payload }) => {},
  rejected: (state, { payload }) => {},
}

/////////////////////////////MY CARD

let connectCardAndCustomer = async ({ cardNumber }, thunkAPI) => {
  const response = await myConnections.post({
    path: "customers_protected/add_card_to_customer",
    data: {
      P_CARD_NUMBER: cardNumber,
      P_CARD_TYPE: "P",
    },
    headers: {},
    thunkAPI: thunkAPI,
  })

  return response
}

connectCardAndCustomer = createAsyncThunk(
  `${sliceName}/connectCardAndCustomer`,
  connectCardAndCustomer
)

connectCardAndCustomer.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, action) => {},
  rejected: (state, action) => {},
}

/////////////////////////////GIVEAWAY

let joinGiveaway = async (
  { giveawayId, permission1, permission2 },
  thunkAPI
) => {
  const response = await myConnections.post({
    path: "customers_protected/join_giveaway",
    data: {
      P_GIVEAWAY_ID: giveawayId,
      P_PERMISSION1: permission1 ? "Y" : "N",
      P_PERMISSION2: permission2 ? "Y" : "N",
    },
    headers: {},
    thunkAPI: thunkAPI,
  })

  return response
}

joinGiveaway = createAsyncThunk(`${sliceName}/joinGiveaway`, joinGiveaway)

joinGiveaway.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, action) => {},
  rejected: (state, action) => {},
}

let markMessageAsSeen = async ({ messageID }, thunkAPI) => {
  const response = await myConnections.post({
    path: "customers_protected/set_seen_on_message",
    data: {
      P_MESSAGE_ID: messageID,
    },
    headers: {},
    thunkAPI: thunkAPI,
  })

  return response
}
markMessageAsSeen = createAsyncThunk(
  `${sliceName}/markMessageAsSeen`,
  markMessageAsSeen
)
markMessageAsSeen.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, action) => {},
  rejected: (state, action) => {},
}

/*
  ____  ___  _   _  _  __ ____    ___   _   _  _____   __  __  _____  _____  ___   ____   _____ 
 / ___||_ _|| \ | || |/ /|  _ \  / _ \ | \ | || ____| |  \/  || ____||_   _|/ _ \ |  _ \ | ____|
 \___ \ | | |  \| || ' / | |_) || | | ||  \| ||  _|   | |\/| ||  _|    | | | | | || | | ||  _|  
  ___) || | | |\  || . \ |  _ < | |_| || |\  || |___  | |  | || |___   | | | |_| || |_| || |___ 
 |____/|___||_| \_||_|\_\|_| \_\ \___/ |_| \_||_____| |_|  |_||_____|  |_|  \___/ |____/ |_____|                                                                                             
                                                     
*/

/*
  ____   _      ___  ____  _____ 
 / ___| | |    |_ _|/ ___|| ____|
 \___ \ | |     | || |    |  _|  
  ___) || |___  | || |___ | |___ 
 |____/ |_____||___|\____||_____|
                                 
*/

const loadingSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserInfo.pending, getUserInfo.myLC.pending)
    builder.addCase(getUserInfo.fulfilled, getUserInfo.myLC.fulfilled)
    builder.addCase(getUserInfo.rejected, getUserInfo.myLC.rejected)

    builder.addCase(updateCustomer.pending, updateCustomer.myLC.pending)
    builder.addCase(updateCustomer.fulfilled, updateCustomer.myLC.fulfilled)
    builder.addCase(updateCustomer.rejected, updateCustomer.myLC.rejected)

    builder.addCase(changePassword.pending, changePassword.myLC.pending)
    builder.addCase(changePassword.fulfilled, changePassword.myLC.fulfilled)
    builder.addCase(changePassword.rejected, changePassword.myLC.rejected)

    builder.addCase(markMessageAsSeen.pending, markMessageAsSeen.myLC.pending)
    builder.addCase(
      markMessageAsSeen.fulfilled,
      markMessageAsSeen.myLC.fulfilled
    )
    builder.addCase(markMessageAsSeen.rejected, markMessageAsSeen.myLC.rejected)

    builder.addCase(
      connectCardAndCustomer.pending,
      connectCardAndCustomer.myLC.pending
    )
    builder.addCase(
      connectCardAndCustomer.fulfilled,
      connectCardAndCustomer.myLC.fulfilled
    )
    builder.addCase(
      connectCardAndCustomer.rejected,
      connectCardAndCustomer.myLC.rejected
    )

    builder.addCase(joinGiveaway.pending, joinGiveaway.myLC.pending)
    builder.addCase(joinGiveaway.fulfilled, joinGiveaway.myLC.fulfilled)
    builder.addCase(joinGiveaway.rejected, joinGiveaway.myLC.rejected)
  },
})

export const getters = {
  getCupons: (state) => state[stateName].rewards.cupons,
  getCuponsCount: (state) => state[stateName].rewards.cupons.length,
}

export const asyncActions = {
  getUserInfo,
  updateCustomer,
  markMessageAsSeen,
  changePassword,
  connectCardAndCustomer,
  joinGiveaway,
}
export const actions = loadingSlice.actions
export default loadingSlice.reducer
